import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './AboutPage.module.css';

const SectionHero = () => {
  return (
    <div className={css.heroContainer}>
      <div className={css.heroContent}>
        <h1 className={css.heroTitle}>
          <FormattedMessage id="AboutPage.heroTitle" />
        </h1>
      </div>
    </div>
  );
};

export default SectionHero;
